import { api } from '../apiClient';

export const authAPI = {
  login: (email: string, password: string, customerCode?: string) => {
    return api.post('/auth/login', { email, password, customer_code: customerCode });
  },
  
  getGoogleAuthUrl: (customerCode?: string) => {
    const params = customerCode ? { customer_code: customerCode } : {};
    return api.get('/auth/google/login', { params });
  },
  
  googleCallback: (code: string, state?: string) => {
    const params: { code: string; state?: string } = { code };
    if (state) {
      params.state = state;
    }
    // 인증 코드는 한 번만 쓸 수 있어 재시도하지 않는다 (#51)
    return api.get('/auth/google/callback', { params, __noRetry: true } as any);
  },
  
  getCurrentUser: () => {
    return api.get('/auth/me').then(response => response.data);
  },
  
  logout: () => {
    return api.post('/auth/logout', {}, { withCredentials: true });
  }
};

